import { BaseCard } from '@cksoftware/react-base';
import { PropsWithChildren } from 'react';

type AuctionCardProps = PropsWithChildren & {
  onClick: () => void;
  color: string;
};

export const AuctionCard = (props: AuctionCardProps) => {
  const { color, onClick, children } = props;
  return (
    <BaseCard
      _hover={{ bg: 'gray.50', cursor: 'pointer' }}
      onClick={onClick}
      borderTop={`2px solid ${color}`}
      width={'100%'}
      bodyProps={{ padding: '0' }}>
      {children}
    </BaseCard>
  );
};
